import { useEffect, useRef } from "react";
import Tooltip from "bootstrap/js/dist/tooltip";

export default function useTooltip<T extends HTMLElement>(title?: string) {
  const elemRef = useRef<T>(null);

  useEffect(() => {
    if (elemRef.current) {
      Tooltip.getOrCreateInstance(elemRef.current);
    }

    return function () {
      if (elemRef.current) Tooltip.getInstance(elemRef.current)?.dispose();
    };
  }, [elemRef.current]);

  useEffect(() => {
    if (elemRef.current && title) {
      const tooltipInstance = Tooltip.getInstance(elemRef.current);
      if (tooltipInstance) {
        tooltipInstance.setContent({
          ".tooltip-inner": title,
        });
      }
    }
  }, [title]);

  return elemRef;
}
